import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { profile } from "../mock/mock";
import { api } from "../lib/api";
import { Reveal } from "../components/Reveal";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast("A few fields are missing");
      return;
    }
    setSending(true);
    try {
      await api.post("/contact", form);
      setSent(true);
      toast("Message received. Thank you.");
      setForm({ name: "", email: "", message: "" });
      setTimeout(() => setSent(false), 3500);
    } catch (err) {
      const d = err.response?.data?.detail;
      toast(typeof d === "string" ? d : "Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <section
      id="contact"
      data-theme="dark"
      className="sec-dark relative px-6 md:px-12 pt-28 md:pt-40 pb-12"
      data-testid="contact-section"
    >
      <div className="max-w-[1240px] mx-auto">
        <Reveal>
          <div className="eyebrow">05 · Let's Learn Together</div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-extrabold text-[38px] md:text-[68px] lg:text-[84px] leading-[0.98] t-fg tracking-[-0.04em] mt-8 mb-16 md:mb-24 max-w-[16ch]">
            Write, and let's find what we can build<span className="t-terra">.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="grid grid-cols-12 gap-x-6 md:gap-x-16 gap-y-12">
            <div className="col-span-12 md:col-span-5 space-y-8">
              <a
                href={`mailto:${profile.email}`}
                className="block text-[18px] md:text-[21px] t-fg tracking-[-0.015em]"
                data-testid="reach-email"
              >
                <span className="link-underline">{profile.email}</span>
              </a>
              <a
                href={profile.linkedin}
                target="_blank"
                rel="noreferrer"
                className="block text-[18px] md:text-[21px] t-fg tracking-[-0.015em]"
                data-testid="reach-linkedin"
              >
                <span className="link-underline">{profile.linkedinShort}</span>
              </a>
            </div>

            <div className="col-span-12 md:col-span-7">
              <form onSubmit={submit} className="space-y-8" data-testid="reach-form">
                <input
                  type="text"
                  value={form.name}
                  onChange={(e) => setForm({ ...form, name: e.target.value })}
                  className="input-line"
                  placeholder="Name"
                  data-testid="reach-input-name"
                />
                <input
                  type="email"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  className="input-line"
                  placeholder="Email"
                  data-testid="reach-input-email"
                />
                <textarea
                  rows={4}
                  value={form.message}
                  onChange={(e) => setForm({ ...form, message: e.target.value })}
                  className="input-line resize-none"
                  placeholder="Message"
                  data-testid="reach-input-message"
                />
                <button
                  type="submit"
                  disabled={sending}
                  className="btn-pill group disabled:opacity-60"
                  data-testid="reach-submit"
                >
                  {sent ? "Sent" : sending ? "Sending…" : "Send"}
                  <ArrowRight
                    size={14}
                    strokeWidth={1.8}
                    className="transition-transform duration-500 ease-out group-hover:translate-x-1"
                  />
                </button>
              </form>

              <div className="mt-16">
                <img
                  src="/assets/signature.png"
                  alt=""
                  aria-hidden="true"
                  className="signature w-32 md:w-40 -ml-2"
                />
              </div>
            </div>
          </div>
        </Reveal>

        <div
          className="mt-24 md:mt-32 pt-8 border-t flex items-center justify-between text-[12px] t-faint"
          style={{ borderColor: "var(--hair-soft)" }}
        >
          <span>© {new Date().getFullYear()} {profile.name}</span>
          <span>Designed as a story, not a résumé.</span>
        </div>
      </div>
    </section>
  );
};

export default Contact;
